import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IAuthState } from '../types';

export const authModuleName = 'auth';

const initialState: IAuthState = {
  userData: {},
  isLoggedIn: false,
  isShowAuthModal: false,
  returnUrl: null,
};

export const authSlice = createSlice({
  initialState,
  name: authModuleName,
  reducers: {
    actionSetUserData(state, { payload }: PayloadAction<IAuthState['userData']>) {
      state.userData = payload;
      state.isLoggedIn = Boolean(payload?.id);
    },
    actionSetShowSudirAuthModal(state, { payload }: PayloadAction<IAuthState['returnUrl']>) {
      state.isShowAuthModal = true;
      state.returnUrl = payload;
    },
    actionSetCloseSudirAuthModal(state) {
      state.isShowAuthModal = false;
      state.returnUrl = null;
    },
    actionSetInvalidateUserData(state) {
      state.userData = {};
      state.isLoggedIn = false;
    },
  },
});

export const {
  actions: { actionSetUserData, actionSetShowSudirAuthModal, actionSetCloseSudirAuthModal, actionSetInvalidateUserData },
} = authSlice;

export const { reducer: authReducer } = authSlice;
